import React from 'react';
import { Button } from 'reactstrap';
import { FormPrices } from './FormPrices';
import { ModalButtonSave, ModalButtonUpdate, ModalButtonDelete } from '../../constant';
import { DeletePrices } from './DeletePrices';
import { Dialog } from 'primereact/dialog';

export const ModalPrices = (props) => {

    const {
        modal, closeDialog, modalTitle, method, loading,
        handleInputChange, handlePickerValues, validacionesPrice,
        price, from, to, id_examProfile,
        saveCreate, saveUpdate, saveDelete,
        examProfileState,
        validInputDate, validToInputDate,
        isCurve, curves, addCurve, editCurve,
    } = props;

    const footer = (
        <div
            className='mt-2'
            style={{
                display: "flex",
                justifyContent: "flex-end",
                
            }}
        >
            <Button
                color="danger"
                size="sm"
                onClick={closeDialog}
                disabled={loading}
            >
                Cancelar
            </Button>

            <Button
                color="primary"
                size="sm"
                onClick={method === "create" ? saveCreate : saveUpdate}
                disabled={loading}
                className={loading ? "progress-bar-animated progress-bar-striped" : ""}
            >
                {
                    loading
                    ?
                        <>
                            <i className="fa fa-spinner fa-spin mr-1"></i>
                            Guardando...
                        </>
                    :
                        "Guardar"
                }
            </Button>
        </div>
    );

    return (
        <Dialog 
                header={modalTitle}
                visible={modal}
                onHide={closeDialog}
                closable={true}
                modal
                blockScroll
                className='medium-dialog'
                footer={footer}
                style={{ overflow: 'visible' }}
                contentStyle={{ overflow: 'visible' }}
            >
            {
                method === "create"
                    ? <FormPrices
                        button={ModalButtonSave}
                        {...{ closeDialog, loading, handleInputChange, from, validacionesPrice, methodAction: saveCreate, id_examProfile, examProfileState, handlePickerValues, validInputDate, validToInputDate, isCurve, curves, addCurve, editCurve }}
                    />
                    : (method === "update")
                        ? <FormPrices
                            button={ModalButtonUpdate}
                            {...{ closeDialog, loading, handleInputChange, price, from, to, validacionesPrice, methodAction: saveUpdate, id_examProfile, examProfileState, handlePickerValues, validInputDate, validToInputDate }}
                        />
                        : null
                        // : <DeletePrices {...{ closeDialog, loading, price, saveDelete }} />
            }
        </Dialog>
    )
}
